import { useEffect } from 'react';
import { register } from 'utils/serviceWorker';
import useIntlToast from 'hooks/useIntlToast';

const ServiceWorkerUpdateManager = () => {
  const showIntlToast = useIntlToast();

  useEffect(() => {
    const handleUpdate = (registration) => {
      const waitingServiceWorker = registration.waiting;

      if (waitingServiceWorker) {
        waitingServiceWorker.addEventListener('statechange', (event) => {
          if (event.target.state === 'activated') {
            window.location.reload();
          }
        });

        showIntlToast(
          'info',
          'app.update.automatic',
          {},
          {
            position: 'top-center',
            autoClose: 2000,
            closeOnClick: false,
          },
        );

        waitingServiceWorker.postMessage({ type: 'SKIP_WAITING' });
      }
    };

    register({
      onUpdate: handleUpdate,
    });

    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.getRegistration().then((registration) => {
        if (registration && registration.waiting) {
          handleUpdate(registration);
        }
      });
    }
  }, [showIntlToast]);

  return null;
};

export default ServiceWorkerUpdateManager;
